import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Input, Button, Dropdown, Modal, Space } from "antd";
import { MoreOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  updateGroupIdentityMembership,
  updateGroupMemberGroupComment,
} from "../../actions/api";
import { errorAction, successAction, types } from "@authzsvc/api-lib";
import { showErrorNotification, showSuccessNotification } from "../../util";

const GroupMembershipComment = ({ record, selectedGroupId, disabled }) => {
  const dispatch = useDispatch();

  const [comment, setComment] = useState(record.comment || "");
  const [isEditing, setIsEditing] = useState(false);
  const [originalComment, setOriginalComment] = useState(record.comment || "");
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleEdit = () => setIsEditing(true);

  const handleCancel = () => {
    setComment(originalComment);
    setIsEditing(false);
  };

  const handleSave = async () => {
    await postComment(comment);
    setOriginalComment(comment);
    setIsEditing(false);
  };

  const postComment = async (comment) => {
    let response;
    if (record.memberIdentity) {
      response = await dispatch(
        updateGroupIdentityMembership(
          selectedGroupId,
          record.memberIdentity.id,
          comment
        )
      );
    } else {
      response = await dispatch(
        updateGroupMemberGroupComment(
          selectedGroupId,
          record.memberGroup.id,
          comment
        )
      );
    }

    const isSuccessAction =
      response.type ===
        successAction(types.UPDATE_GROUP_MEMBER_IDENTITY_COMMENT) ||
      response.type === successAction(types.UPDATE_GROUP_MEMBER_GROUP_COMMENT);

    const isErrorAction =
      response.type === errorAction(types.UPDATE_GROUP_IDENTITY_MEMBERSHIP) ||
      response.type === errorAction(types.UPDATE_GROUP_MEMBER_GROUP_COMMENT);

    if (isSuccessAction) {
      if (String(comment).trim() === "") {
        showSuccessNotification("Comment deleted successfully");
      } else if (String(comment).trim() !== "") {
        showSuccessNotification("Comment updated successfully");
      }
    } else if (isErrorAction) {
      showErrorNotification("Error", "An error occurred updating the comment");
    }
  };

  const handleDelete = () => setConfirmOpen(true);

  const confirmDelete = async () => {
    setComment("");
    setOriginalComment("");
    setConfirmOpen(false);
    await postComment("");
  };

  const cancelDelete = () => setConfirmOpen(false);

  const menuItems = [
    {
      key: "edit",
      icon: <EditOutlined />,
      label: "Edit comment",
      onClick: handleEdit,
      disabled: isEditing,
    },
    {
      key: "delete",
      icon: <DeleteOutlined />,
      label: "Delete comment",
      onClick: handleDelete,
      disabled: comment === "" || isEditing,
      danger: true,
    },
  ];

  return (
    <div>
      <Space.Compact block>
        <Input
          value={comment}
          disabled={!isEditing}
          onChange={(e) => setComment(e.target.value)}
          aria-label="Comment"
        />
        <Dropdown
          menu={{ items: menuItems }}
          trigger={["click"]}
          disabled={isEditing || disabled}
          placement="bottomRight"
        >
          <Button icon={<MoreOutlined />} />
        </Dropdown>
      </Space.Compact>
      {isEditing && (
        <Space style={{ marginTop: 8 }}>
          <Button onClick={handleSave} type="primary">
            Save
          </Button>
          <Button onClick={handleCancel}>Cancel</Button>
        </Space>
      )}
      <Modal
        title={
          <>
            <DeleteOutlined style={{ marginRight: 8, color: "#ff4d4f" }} />
            Confirm Deletion
          </>
        }
        centered
        open={confirmOpen}
        onCancel={cancelDelete}
        onOk={confirmDelete}
        okButtonProps={{ danger: true }}
      >
        Are you sure you want to delete this comment?
      </Modal>
    </div>
  );
};

export default GroupMembershipComment;
